module.exports = __webpack_public_path__ + "img/tick.8c7a86ae.svg";